import React from "react";
import UlLi, { scrollTo, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Tabs, Tab, Glyphicon} from "react-bootstrap";
import Highlight from "react-highlight";
import { Navigation, Link } from "react-router";
import UserHandler from "js/utilities/user-handler";
import SDKSidebar from "js/utilities/sdk-sidebar"
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import ApptokenDisplay from "js/utilities/get-display-apptoken";
import { ZOOM_ICON } from "js/config.jsx";

export default React.createClass({
  displayName: "release-notes",
  scrollToGuide : null,
  scrollingEl : null,
  getInitialState: function() {
    var data  = [{}];
    var scrollToElement = initDeepLinkData(this.props);

    return {
            data: data,
            navMenuParent: null,
            navMenu: null,
            scrollToElement: scrollToElement
          };
  },

  componentDidMount: function() {
    this.scrollingEl = document.getElementById("scrollingEl");
    mountCode(this);
    this.scrollToGuide = this.props.location.query.location;
    scrollingEl.scrollTop = 0;
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function() {
    const appToken = "Sign up to get your own Key .";
    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container release-practices">

              <section>
                <div className="title">
                  <Glyphicon glyph="pencil" />
                  <h2 id="zoom-release-practices">FaceTec Release Practices</h2>
                </div>
                <p>This guide describes FaceTec's release practices, cadence, and other FaceTec release information..</p>
                <hr/>
              </section>

              <section>
                <h3 id="overview-and-goals">Overview and Goals</h3>
                <p>FaceTec's primary goals are:</p>
                <ul>
                  <li><p>Provide a secure, stable, and reliable library that achieves high Usability & Success Rates.</p></li>
                  <li><p>Steadily improve the product, and improve the product as rapidly as possible.</p></li>
                  <li><p>Ensure that the developer experience is stable and predictable.</p></li>
                </ul>

                <p>The above goals can sometimes be in conflict.  For instance, we may release versions of our product more rapidly during periods of time where internal R&D efforts are providing rapid and consistent gains.  FaceTec may, at its discretion, deprecate features that have proven to hurt security or usability.</p>
                <hr />
              </section>

              <section>
                <h3 id="device-and-server-version-compatibility">Device and Server Version Compatibility</h3>
                <p>It is important to use the following guidance when updating FaceTec Device and Server SDKs:</p>
                <ul>
                  <li><p>The "latest version" of FaceTec Server is <strong>ALWAYS</strong> backwards compatible with FaceMaps generated from Device SDKs released at the same time or before.</p></li>
                  <li><p>Conversely, FaceMaps generated with a particular version of the Device SDKs <strong>ARE NEVER</strong> guaranteed to work with older versions of the Server SDK.</p></li>
                  <li><p>Another way to think about this is: <strong>"If you are upgrading FaceTec SDKs, always AT LEAST update FaceTec Server to latest, and the upgrade is 100% safe."</strong></p></li>
                </ul>

                <hr />
              </section>

              <section>
                <h3 id="versioning">Versioning</h3>
                <p>FaceTec versioning can be used to assess the general level of change for a given release.  FaceTec versions are denoted with <code>major.minor.patch</code> parts.</p>
              </section>

              <section>
                <h3 id="major-versions">Major Versions</h3>
                <p>FaceTec major version indicates changes that:</p>
                <ul>
                  <li><p>Are generally for large changes to the libraries.</p></li>
                  <li><p>May require you to update APIs, refactor code, and/or learn new APIs.</p></li>
                  <li><p>May contain new, required security or usability features.</p></li>
                  <li><p>May require you to re-test your core, FaceTec-related functionality.</p></li>
                </ul>
              </section>

              <section>
                <h3 id="minor-versions">Minor Versions</h3>
                <p>FaceTec minor version indicates changes that:</p>
                <ul>
                  <li><p>Are generally for medium-sized changes to the libraries.</p></li>
                  <li><p>Are not breaking, unless documented in the <Link to="/release-notes">Release Notes</Link>.</p></li>
                  <li><p>Do not change behavior, unless documented in the <Link to="/release-notes">Release Notes</Link>.</p></li>
                  <li><p>Will often include underlying algorithm accuracy improvements.</p></li>
                  <li><p>Will often include underlying performance and compatibility improvements.</p></li>
                  <li><p>May include API additions, deprecations, or removals.  If they do, they will be documented in the <Link to="/release-notes">Release Notes</Link>.</p></li>
                </ul>
              </section>

              <section>
                <h3 id="patch-versions">Patch Versions</h3>
                <p>FaceTec patch version indicates changes that:</p>
                <ul>
                  <li><p>Are generally made for small, incremental changes to the libraries.</p></li>
                  <li><p>Are not breaking, unless documented in the <Link to="/release-notes">Release Notes</Link>.</p></li>
                  <li><p>Do not change behavior, unless documented in the <Link to="/release-notes">Release Notes</Link>.</p></li>
                  <li><p>Will often include underlying algorithm accuracy improvements.</p></li>
                  <li><p>Will often include underlying performance and compatibility improvements.</p></li>
                  <li><p>May include API additions, deprecations, or removals.  If they do, they will be documented in the <Link to="/release-notes">Release Notes</Link>.</p></li>
                </ul>
                <hr />
              </section>

              <section>
                <h3 id="release-cadence">Release Cadence</h3>
                <p>FaceTec releases updates to the FaceTec SDKs, in general, every 1-2 weeks.</p>
                <hr />
              </section>

              <section>
                <h3 id="good-bug">"I reported a valid, good bug.  When will it be in the FaceTec SDK Product?"</h3>
                <p>If the issue is truly blocking integration, FaceTec will make a best effort to resolve the issue or provide a workaround in 1-2 days.</p>
                <p>Valid crashes or hangs are considered Priority 0, and FaceTec is likely to release a fix within 1-2 days.</p>
                <p>All other issue types will be taken on a case-by-case basis -- but FaceTec generally fixes the vast majority of issues reported within our 1-2 week release cycle.</p>
                <p>FaceTec will communicate to you an ETA for your issue once it has been identified as valid.</p>
                <hr />
              </section>

              <section>
                <h3 id="deprecations">Deprecations, Removals, and Breaking Changes</h3>
                <p>In general, FaceTec uses platform deprecation features to notify developers of upcoming changes to the platform.  We will also add a <Link to="/release-notes">Release Note</Link> to notify of upcoming changes.</p>
                <p>FaceTec will make a best effort to remove deprecated APIs from the platform in <code>minor</code> version revisions, but due to our policies and reasoning around <Link to="/updating">Keeping Up-to-Date</Link>, FaceTec may choose to deprecate or remove deprecated APIs in any release.</p>
              </section>
            </div>
            <SDKSidebar menuType="main" title="Release Notes"/>
          </div>
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/release-practices.jsx